import { render } from "./TheCoreData.vue?vue&type=template&id=0317bd66&scoped=true&lang=true"
import script from "./TheCoreData.vue?vue&type=script&lang=js"
export * from "./TheCoreData.vue?vue&type=script&lang=js"

import "./TheCoreData.vue?vue&type=style&index=0&id=0317bd66&scoped=true&lang=css"

import exportComponent from "/home/runner/work/kv-cloud-pbx/kv-cloud-pbx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0317bd66"]])

export default __exports__